import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { Page } from "@digital-services/shell";
import {
  Button,
  Card,
  DataError,
  LoadingIndicator,
  Typography
} from "@digital-services/ui";
import { CopyToClipboard } from "@ds-cps/ui";

import { apiUsersRoute, editApiUserNameRoute } from "@api-users/common";
import { DeleteApiUserButton } from "@api-users/part-1-api-user/components/DeleteApiUserButton";
import { useGetApiUserById } from "@api-users/part-1-api-user/services/use-get-api-user-by-id";
import { TabsSecondLevel } from "@api-users/part-2-api-secrets/components/TabsSecondLevel";

import EditIcon from "@icons/edit.svg?react";
import { formatterShort } from "@utils/time-utils";

export const EditApiUserPage = () => {
  const navigate = useNavigate();
  const { t: tApiUsers } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  const { apiUserId } = useParams();
  const { apiUser, isLoading, error } = useGetApiUserById(apiUserId!);

  if (isLoading) {
    return (
      <div className="flex w-full items-center text-base">
        <LoadingIndicator label={tApiUsers("messages.user-loading")} />
      </div>
    );
  }

  if (error) {
    return (
      <DataError
        title={tApiUsers("messages.user-error")}
        message=""
        variant="primary"
        onRefresh={() => {
          globalThis.location.reload();
        }}
      />
    );
  }

  if (!apiUser) {
    return;
  }

  return (
    <Page title={`API user '${apiUser.name}'`}>
      <div className="flex min-w-[440px] justify-end gap-6">
        <Button
          variant="ghost"
          size="big"
          onClick={() => {
            navigate(apiUsersRoute);
          }}
        >
          Cancel
        </Button>

        <Button
          variant="ghost"
          size="big"
          icon={<EditIcon />}
          onClick={() => {
            navigate(editApiUserNameRoute(apiUser.id));
          }}
        >
          Edit
        </Button>

        {/* TBD use context */}
        {false ? <DeleteApiUserButton apiUserId={apiUser?.id} /> : null}
      </div>

      <div className="flex">
        <Card className="w-[50%] min-w-[440px]">
          <div
            className="grid grid-flow-col grid-rows-2 gap-4"
            data-testid={`api-user-details-tile`}
          >
            {/* LABELS */}
            <Typography className="self-center">API User ID</Typography>
            <Typography className="self-center">Created on</Typography>

            {/* VALUES */}
            <Typography className="font-bold">
              {apiUser.id}

              <CopyToClipboard
                value={apiUser.id}
                message={"API User ID is copied to clipboard"}
              />
            </Typography>
            <Typography className="font-bold">
              {formatterShort(apiUser.createdOn)}
            </Typography>
          </div>
        </Card>
      </div>

      <TabsSecondLevel />
    </Page>
  );
};
